export const ULLY_WHATSAPP_PHONE = '5511933058481';

export const ULLY_WHATSAPP_PHONE_LABEL = '+55 11 93305-8481';

export const ULLY_WHATSAPP_PREFILL_TEXT = '';

export const ULLY_REDIRECT_DELAY_MS = 2200;

export const ULLY_MOBILE_BREAKPOINT = 768;

export const LEGACY_DIRECTTALK_ENABLED = false;

const prefillQuery = ULLY_WHATSAPP_PREFILL_TEXT
  ? `&text=${encodeURIComponent(ULLY_WHATSAPP_PREFILL_TEXT)}`
  : '';

export const ULLY_WHATSAPP_APP_URL = `https://wa.me/${ULLY_WHATSAPP_PHONE}${
  ULLY_WHATSAPP_PREFILL_TEXT
    ? `?text=${encodeURIComponent(ULLY_WHATSAPP_PREFILL_TEXT)}`
    : ''
}`;

export const ULLY_WHATSAPP_WEB_URL = `https://web.whatsapp.com/send?phone=${ULLY_WHATSAPP_PHONE}${prefillQuery}`;
